/*
 * @Author: changcheng
 * @LastEditTime: 2022-09-26 09:35:50
 */
import "./_style.scss";
export function Header() {
  return (
    <div>
      <div className="player_header">
        <div className="title">
          <span>县域学习平台</span>
          {/* <p>Learning Platform for County Hospital</p> */}
        </div>
      </div>
    </div>
  );
}
